$(document).ready(function () {
  $("#Metric-form, #Imperial-form").submit(function (event) {
    event.preventDefault();
    var formData = $(this).serializeArray();
    var dataType = $(this).data("id");
    var keyValueArray = [];
    var feetValue = "";
    var inchesValue = "";
    var weightKg = "";
    $.each(formData, function (index, field) {
      if (
        dataType === "imperial" &&
        (field.name === "feet" || field.name === "inches")
      ) {
        if (field.name === "feet") {
          feetValue = field.value;
        } else if (field.name === "inches") {
          inchesValue = field.value;
        }
        var heightValue = feetValue + "." + inchesValue;
        if (field.name === "inches") {
          var keyValue = { height: heightValue };
          keyValueArray.push(keyValue);
        }
      } else {
        var keyValue = {};
        keyValue[field.name] = field.value;
        keyValueArray.push(keyValue);
      }
      if (field.name === "weightlbs") {
        var weightLbs = parseFloat($("[name='weightlbs']").val());
        weightKg = weightLbs * 0.453592;
        console.log(weightKg, "l00");
      }
    });
    console.log(keyValueArray);
    var heightIndexValues = [];
    var weightIndexValues = [];
    if ($(".youth_option").length == 1 && keyValueArray[2]["age"] <= 14) {
      console.log(dataType);
      if (dataType === "imperial") {
        $("#metric-youth tr:gt(0) td:nth-child(2)").each(function (index) {
          var value = $(this).text();
          var splitValue = value.split("-");
          heightIndexValues.push(splitValue);
        });
      } else {
        $("#metric-youth tr:gt(0) td:first-child").each(function () {
          var value = $(this).text();
          var splitValue = value.split("-");
          heightIndexValues.push(splitValue);
        });
      }
      $("#metric-youth tr:first-child td").each(function (index) {
        if (index != 0 && index != 1) {
          var value = $(this).text();
          var splitValue = value.split("-");
          weightIndexValues.push(splitValue);
        }
      });
    } else {
      if (dataType === "imperial") {
        $("#metric-table tr:gt(0) td:nth-child(2)").each(function () {
          var value = $(this).text();
          var splitValue = value.split("-");
          heightIndexValues.push(splitValue);
        });
      } else {
        $("#metric-table tr:gt(0) td:first-child").each(function (index) {          
            var value = $(this).text();
            var splitValue = value.split("-");
            heightIndexValues.push(splitValue);
        });
      }
      $("#metric-table tr:first-child td").each(function (index) {
        if (index != 0 && index != 1) {
          var value = $(this).text();
          var splitValue = value.split("-");
          weightIndexValues.push(splitValue);
        }
      });
    }


   console.log(heightIndexValues);
    var heightindex = 1;
    for (var i = 0; i < heightIndexValues.length; i++) {
      var oki = i + 1;
      var value = heightIndexValues[i];
      // console.log("kalu " + heightIndexValues.length);
      console.log("jadu " + oki);
      // console.log("oalo " + value[1]);
      // console.log("padu " + Number(keyValueArray[0]["height"]));      
      if (value[0] <= Number(keyValueArray[0]["height"]) && value[1] > Number(keyValueArray[0]["height"])) {
        console.log("pilo");
        heightindex = heightindex + i;
        break;
      }else if(heightIndexValues.length == oki && value[1] == Number(keyValueArray[0]["height"])){
        heightindex = heightindex + i;
        console.log("pilu");
        break;
      }else{
        if ((heightIndexValues.length - 1) == i) {
          heightindex = undefined;
        }
      }
    }
    console.log(heightindex);
    
    // console.log(heightIndexValues);
    // var heightindex = 1;
    // for (var i = 0; i < heightIndexValues.length; i++) {
    //   var value = heightIndexValues[i];
    //   var lastHeightValue = heightIndexValues[heightIndexValues.length - 1][1];
    //   console.log("value: " + Number(keyValueArray[1]["height"]);
      
    //   if (value[0] <= Number(keyValueArray[0]["height"]) && value[1] > Number(keyValueArray[0]["height"])) {
    //     heightindex = heightindex + i;
    //     break;
    //   }else if(heightIndexValues.length == i && value[0] == Number(keyValueArray[1]["height"])){
    //       // heightindex = heightindex + i;
    //       // break;
    //       console.log("Last height value: " + lastHeightValue);
    //       console.log("heightIndexValues" + heightIndexValues.length);        
    //    }else{
    //     if ((heightIndexValues.length - 1) == i) {
    //       heightindex = undefined;
    //     } 
    //   }
    // }
    // console.log(heightindex);



    console.log(weightIndexValues);
    var weightindex = 2;
    for (var i = 0; i < weightIndexValues.length; i++) {
      var value = weightIndexValues[i];
      console.log(weightKg);
      if (weightKg != "") {
        if (value[0] <= weightKg && value[1] > weightKg) {
          weightindex = weightindex + i;
          break;
        }else{
          if ((weightIndexValues.length - 1) == i) {
            weightindex = undefined;
          }
        }
      } else {
        if (value[0] <= parseInt(keyValueArray[1]["weight"]) && value[1] > parseInt(keyValueArray[1]["weight"])) {
          weightindex = weightindex + i;
          break;
        } else {
          if ((weightIndexValues.length - 1) == i) {
            weightindex = undefined;
          }
        }
      }
    }
    console.log(weightindex);

    // Accessing the specific value from the table based on heightindex and weightindex
    var specificValue = "";
    console.log("bhondu double 8");
    if ($(".youth_option").length == 1 && keyValueArray[2]["age"] <= 14) {
      specificValue = $("#metric-youth tr").eq(heightindex).find("td").eq(weightindex).text();
    } else {
      specificValue = $("#metric-table tr").eq(heightindex).find("td").eq(weightindex).text();
      console.log("bhondu 8");
    }

    if(heightindex == undefined || weightindex ==  undefined || heightindex == '' || weightindex == ' '){
      $("#fit-let").text(" : Unable to find your size" + specificValue);
    }else{
      $("#fit-let").text(" : " + specificValue);
    }
    console.log(specificValue);
    $(".modal-table .slide-fit-form").hide();
    $(".modal-table .slide-fit-size").show();
  });

  
  $("#form-button-reset").click(function () {
    $("#Metric-form input:not([type='submit']").val("");
    $("#Imperial-form input:not([type='submit']").val("");
    $("#fit-let").text("");
    $(".modal-table .slide-fit-form").show();
    $(".modal-table .slide-fit-size").hide();
  });
});